import {app} from '../app';


export class HomeController {

    private rootScope:IRootScope;
    private http:ng.IHttpService;
    private window:IWindowService;
    private store:ng.a0.storage.IStoreService;
    private authService: any;

    static $inject = ['$rootScope', '$http', '$window', 'store', 'authService'];

    constructor($rootScope:IRootScope,
                $http:ng.IHttpService,
                $window:IWindowService,
                store:ng.a0.storage.IStoreService,
                authService:any) {

        this.rootScope = $rootScope;
        this.http = $http;
        this.window = $window;
        this.store = store;
        this.authService = authService;

        this.rootScope.headerTitle = '';

        const logo = '/public/images/logo_lumina@2x.png';
        this.rootScope.headerLogos = {
            mobile: {
                main: logo,
                secondary: '',
            },
            desktop: {
                right: '',
                left: logo
            },
        };

    }

    pageTitle = 'Lumina Questionnaire';

    logout() {
        // Log out locally
        this.authService.logoutLocally();
    }
}

app.controller('HomeController', HomeController);
